import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactContactGroup } from 'src/app/_models/contact-contact-group.model';
import { ContactGroup, Data } from 'src/app/_models/contact-group.model';
import { Contact } from 'src/app/_models/contact.model';
import { SearchFilterDTO } from 'src/app/_models/search-filter-dto.model';
import { SearchFilter } from 'src/app/_models/search-filter.model';
import { UserContactGroup } from 'src/app/_models/user-contact-group.model';
import { AuthService } from 'src/app/_services/auth.service';
import { ContactGroupService } from 'src/app/_services/contact-group.service';
import { ContactService } from 'src/app/_services/contact.service';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BaseComponent } from 'src/app/common/base/base.component';
import { UserService } from 'src/app/_services/user.service';
import { Formats } from 'src/app/_config/formats';
import { Subscription } from 'rxjs';
import 'jquery';
import 'bootstrap';
import { StorageService } from 'src/app/_services/storage.service';
import { User } from 'src/app/_models/user.model';
import { PagesService } from 'src/app/_services/pages.service';
import { Routes } from 'src/app/_config/routes.config';

@Component({
  selector: 'DCO-contact-data',
  templateUrl: './contact-data.component.html',
  standalone: false,
})
export class ContactDataComponent extends BaseComponent implements OnInit {
  currentFormats: any;

  // languages.start
  private userSuscription$!: Subscription;
  private languagesDownloaded$!: Subscription;
  languages = [];
  private languageChanged$!: Subscription;
  public selectedLanguage = '';
  // languages.end
  username: string;
  menuAbierto = false;
  isEditing: boolean = false;
  tokenData: any;
  showBtnDocumentation: boolean = false;
  contactCount: number;
  notificationOptions = [
    { value: 'email', label: 'DCO.MassiveInformation_Email' },
    { value: 'none', label: 'DCO.Enrollment_Notification_NONE' },
  ];

  userContactGroups: UserContactGroup[] = [];
  contactGroup: ContactGroup[] = [];
  contactGroupData: Data;
  contactContactGroup: ContactContactGroup[] = [];
  contact: Contact[] = [];
  contactPhone: number = 0;
  contactPrefix: number = 0;

  // Defined SearchFilter to userContactGroup
  searchFilter: SearchFilter = {
    search: '',
    order: '',
    top: 10,
  };

  // Defined  SearchFilter to ContactGroup
  searchFilterDTO: SearchFilterDTO = {
    page: 1,
    pageSize: 10,
    search: '',
    order: '',
  };

  constructor(
    public override router: Router,
    public _translationService: LanguageManagerService,
    private authService: AuthService,
    private contactGroupService: ContactGroupService,
    route: ActivatedRoute,
    private storageService: StorageService,
    private _pagesService: PagesService  ) {
    super(router, _translationService, route);
  }

  @HostListener('document:click')
  clickOut() {
    this.menuAbierto = false;
  }

  override ngOnInit(): void {

    super.ngOnInit();
    this.languagesDownloaded$ =
      this.langService.languagesDownloaded$.subscribe((languages) => {
        // cuando termina de cargar los idiomas mostramos el desplegable
        // console.log('enrollment languages',languages)
        this.languages = languages;
      });
    this.languageChanged$ = this.langService.languageChanged$.subscribe(
      (selectedLanguage) => {
        // console.log('enrollment selectedLanguage',selectedLanguage)
        // cuando recibimos el evento de cambiar de idioma cambiamos la seleccion del desplegable
        // eso ocurre al cargar la pagina, el desplegable puede poner el primer valor
        // pero podemos tener guardado un idioma determinado seleccionado
        this.selectedLanguage = selectedLanguage;
      }
    );

    this.currentFormats =
      this.langService.dateAndCurrencyChangeFormat$.subscribe((formats) => {
        this.currentFormats = formats; // Guardamos los formatos actualizados para utilizarlos
      });
    const currentLanguage = this.langService.GetCurrentLanguage();
    this.langService.updateFormats(currentLanguage); // Cargar los formatos iniciales

    this.username = this.storageService.getUsername();
    this.userSuscription$ = this.storageService.userInfo.subscribe((user) => {
      // si se moficia el usuario (login o logout)
      // recibimos el evento, actualizamos el nombre que se ve (o ponemos login)
      this.updateUserData(user);
      // actualizamos las paginas visibles para el usuario
      this._pagesService.Pages_Get();
    });
    this.tokenData = this.authService.getTokenData();
    // this.getUserData();
    this.getContactGroupData(this.tokenData.contactGroupId);
    //Verificamos si ha realizado el enrollment para mostrar solo la información sin poder modificarla.
    if (this.tokenData && this.tokenData.enrollment === 'True') {
      this.showBtnDocumentation = true;
    } else {
      this.showBtnDocumentation = false;
    }

  }

  updateUserData(user: User) {
    if (user) {
      this.username = user.user;
    } else {
      this.username = null;
    }
  }

  logOut() {
    this.authService.logOut();
    this.router.navigate([Routes.LOGIN]); // Redirige al usuario a la página de login
  }

  SetLanguage(lang: any) {
    this._translationService.SetLanguage(lang);
  }

  getContactGroupData(contactGroupId: any) {
    this.contactGroupService.getContactGroup(contactGroupId).subscribe({
      next: (response) => {
        if (response) {
          this.contactGroup = [response];
          // console.log(this.contactGroup)
          this.getPhone()
          // Recuperamos los contacts
          this.getContactData(contactGroupId);
        } else {
          console.error('No contact groups found.');
          this.contactGroup = [];
        }
      },
      error: (error) => {
        console.error('Error fetching ContactGroups:', error);
      },
    });
  }

  getPhone(){
    if (this.contactGroup[0].data && this.contactGroup[0].data.TAG_ContactoMovil1 && this.contactGroup[0].data.TAG_ContactoMovil1.length>0){
    this.contactPrefix = this.contactGroup[0].data.TAG_ContactoMovil1.substring(0, 5)
    this.contactPhone = this.contactGroup[0].data.TAG_ContactoMovil1.substring(5);
    // console.log(this.contactPhone, this.contactPrefix)
    }
  }

  getContactData(contactGroupId: any) {
    this.contactGroupService.getContactsByContactGroupId(contactGroupId).subscribe({
      next: (response) => {
        this.contact = response;
        this.contactCount = this.contact.length;
      },
      error: () => {
        // console.log('Error Fetchig Contact Data: ', error);
      },
    });
  }

  isSelected(optionValue: string): boolean {
    return 'email' === optionValue;
  }

  isDisabled(): boolean {
    return this.showBtnDocumentation;
  }

  // getPreferredLanguage(value: number): string {
  //   const language = this.languageValues.find(lang => lang.value === value);
  //   return language ? language.label : 'No disponible';
  // }

  // Method to update the TAG_TipoEnvioFichAgrupado value when a checkbox is selected(clicked)
  updateSendWay(tipo: string): void {
    if (this.contactGroup && this.contactGroup.length > 0) {
      this.contactGroup[0].data.TAG_TipoEnvioFichAgrupado = tipo;
    }
  }

  updateLanguage(selectedValue: number): void {
    if (this.contactGroup && this.contactGroup.length > 0) {
      this.contactGroup[0].language = selectedValue;
    }
  }
  selectLanguage(language: any) {
    this.langService.SetLanguage(language);
  }

  //Queryparams option
  Next(contactGroupId: any) {
    this.router.navigate(['/document-details'], {
      queryParams: { contactGroupId },
    });
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  cancelEdit() {
    this.isEditing = false;
  }

  saveChanges() {
    this.isEditing = false;
    this.contactGroup[0].data.TAG_TipoEnvioFichAgrupado = 'email';
    this.contactGroup[0].data.TAG_ContactoMovil1 = this.contactPrefix + this.contactPhone;
    const updatedContactGroup: ContactGroup = {
      contactGroupId: this.contactGroup[0].contactGroupId,
      numberContactGroup: this.contactGroup[0].numberContactGroup,
      nameContactGroup: this.contactGroup[0].nameContactGroup,
      registrationDate: this.contactGroup[0].registrationDate,
      language: this.selectLanguage,
      created: this.contactGroup[0].created,
      createdBy: this.contactGroup[0].createdBy,
      lastUpdate: new Date(),
      lastUpdateBy: this.tokenData?.user,
      data: this.contactGroup[0].data,
      typeSend: this.contactGroup[0].typeSend,
    };

    // Convert the ContactGroup object for the API request
    const apiContactGroup: ContactGroup = {
      ...updatedContactGroup,
      data:
        typeof updatedContactGroup.data === 'object'
          ? JSON.stringify(updatedContactGroup.data)
          : updatedContactGroup.data,
    };

    // Call the ContactGroupService to update the contact group
    this.contactGroupService.addUpdate(apiContactGroup).subscribe({
      next: () => {
        // // console.log('Contact group updated successfully');
      },
      error: (error) => {
        console.error('Error updating contact group:', error);
      },
    });

    // actualizamos enrollment
    // this.authService.UpdateEnrolment(this.tokenData.id).then(x=>{
    //   // console.log('enrollment updated successfully');
    // });
    /* this.updateEnrollment();
    this.goHome(); */
  }

  // actualizamos enrollment
  async updateEnrollment(): Promise<void> {
    try {
      await this.authService.UpdateEnrolment(this.tokenData.id);
      // console.log('Enrollment updated successfully');
      this.goHome();
    } catch (error) {
      console.error('Error updating enrollment', error);
    }
  }
}
